<script>
  let name = "daily-magnetograms";
  let year = parseInt(new Date().getFullYear());
  let month = parseInt(new Date().getMonth()) + 1;
  let day = parseInt(new Date().getDate());
  let month2String;
  let day2String;
  let url;
  let selectedDate,
    selectedTimestamp,
    nextTimpestamp,
    nextDate,
    prevTimestamp,
    prevDate;
  let availableYears = [];
  let availableMonths = [];
  let availableDays = [];
  let base_url =
      "https://observatory.geophysik.uni-muenchen.de/geomagnetism/data/datenDay/"

  for (let y = 2001; y <= parseInt(new Date().getFullYear()); y++) {
    availableYears.push(y);
  }

  for (let m = 1; m <= 12; m++) {
    availableMonths.push(m);
  }

  for (let d = 1; d <= 31; d++) {
    availableDays.push(d);
  }

  $: {
    console.log("update url");

    selectedDate = new Date(year, month - 1, day, 0, 0, 0);
    selectedTimestamp = Math.floor(selectedDate.getTime() / 1000);

    year = parseInt(new Date(selectedTimestamp * 1000).getFullYear());
    month = parseInt(new Date(selectedTimestamp * 1000).getMonth() + 1);
    day = parseInt(new Date(selectedTimestamp * 1000).getDate());

    //formatstring for javascript date

    if (month < 10) {
      month2String = "0" + String(month);
    } else {
      month2String = String(month);
    }

    if (day < 10) {
      day2String = "0" + String(day);
    } else {
      day2String = String(day);
    }

    url =
      base_url +
      year +
      "/FUR" +
      year +
      month2String+
      day2String +
      ".JPG";
  }

  function goNext() {
    nextTimpestamp = selectedTimestamp + 24 * 60 * 60;
    nextDate = new Date(nextTimpestamp * 1000);
    year = parseInt(nextDate.getFullYear());
    month = parseInt(nextDate.getMonth()) + 1;
    day = parseInt(nextDate.getDate());
  }

  function goPrev() {
    prevTimestamp = selectedTimestamp - 24 * 60 * 60;
    prevDate = new Date(prevTimestamp * 1000);
    year = parseInt(prevDate.getFullYear());
    month = parseInt(prevDate.getMonth()) + 1;
    day = parseInt(prevDate.getDate());
  }

  function goNow() {
    let timestamp = Math.floor(Date.now() / 1000);
    let now = new Date(timestamp * 1000);
    year = parseInt(now.getFullYear());
    month = parseInt(now.getMonth()) + 1;
    day = parseInt(now.getDate());
  }

</script>

<style>
  main {
    text-align: center;
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
  }

  form {
    max-width: 100%;
    max-height:auto;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  img {
    max-width: 100%;
    max-height: auto;
  }


  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>

<!--<svelte:options tag="daily-magnetograms" /> -->

<main>
  <form action="" method="GET">
    <!-- <label for="year">year:</label> -->
    <select bind:value={year} name="year" id="year" class="form-select col-md-2 ms-md-auto">
      {#each availableYears as ayear}
        <option value={ayear}>{ayear}</option>
      {/each}
    </select>
    <!-- <label for="month">month:</label> -->
    <select bind:value={month} name="month" id="month" class="form-select col-md-1 ms-md-auto">
      {#each availableMonths as amonth}
        <option value={amonth}>{amonth}</option>
      {/each}
    </select>
    <!-- <label for="day">day:</label> -->
    <select bind:value={day} name="day" id="day" class="form-select col-md-1 ms-md-auto">
      {#each availableDays as aday}
        <option value={aday}>{aday}</option>
      {/each}
    </select>
  </form>
  <form action="" method="get" id="navigation">
    <input
      type="submit"
      name="button"
      on:click|preventDefault={goPrev}
      value="Prev"
    />
    <input
      type="submit"
      name="button"
      on:click|preventDefault={goNow}
      value="Now"
    />
    <input
      type="submit"
      name="button"
      on:click|preventDefault={goNext}
      value="Next"
    />
  </form>
  <div>
    <img
      src={url}
      alt=""
      onerror="javascript:this.src=''"
    />
  </div>
</main>
